// Import the React library.
import React from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";


const SalesChart = ({sditems,saleitems}) => {
  
  //const labels = sditems;
   const data = {
    labels: sditems,
    datasets: [ {
         label: "AVT Sales Details",
         //backgroundColor: "#ffc107",
        // borderColor: "#ffc107",
         backgroundColor: "rgb(53, 162, 235)",
         borderColor: "rgba(53, 162, 235, 0.5)",
         data: saleitems, //[5, 10, 15, 2, 20, 30, 45],
    }, ],
  };

 
  return (
    <div style={{width:"100%"}}>
      <Bar data={data} />
    </div>
  );
};

export default SalesChart;